(function () {
  'use strict';

  document.querySelectorAll('[data-dc]').forEach(initSection);

  function initSection(root) {
    var toast = root.querySelector('[data-dc-toast]');
    var grid = root.querySelector('[data-dc-grid]');

    /* ---------- Copy to clipboard ---------- */
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-dc-copy]');
      if (!btn) return;

      var code = btn.getAttribute('data-code') || '';
      var url = btn.getAttribute('data-url');

      copy(code).then(function () {
        flash(btn);
        var card = btn.closest('[data-dc-card]');
        var codeRow = card && card.querySelector('[data-dc-code-row]');
        if (codeRow) codeRow.hidden = false;
        showToast(toast, 'Code "' + code + '" copied ✓');
        if (url) { setTimeout(function () { window.open(url, '_blank', 'noopener'); }, 1200); }
      })
      .catch(function () {
        showToast(toast, 'Press Ctrl/Cmd + C to copy: ' + code);
      });
    });

    function copy(text) {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(text);
      }
      return new Promise(function (resolve, reject) {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy') ? resolve() : reject(); }
        catch (err) { reject(err); }
        document.body.removeChild(ta);
      });
    }

    function flash(btn) {
      var label = btn.querySelector('.dc-card__cta-label');
      if (!label) return;
      var original = label.textContent;
      btn.classList.add('is-copied');
      label.textContent = 'Copied ✓';
      setTimeout(function () {
        btn.classList.remove('is-copied');
        label.textContent = original;
      }, 1800);
    }

    /* ---------- Filtering ---------- */
    var filters = root.querySelectorAll('[data-dc-filter]');
    var resetBtn = root.querySelector('[data-dc-reset]');
    var emptyMsg = root.querySelector('[data-dc-empty]');

    filters.forEach(function (sel) { sel.addEventListener('change', applyFilters); });
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        filters.forEach(function (s) { s.value = ''; });
        applyFilters();
      });
    }

    function applyFilters() {
      if (!grid) return;
      var active = {};
      var any = false;
      filters.forEach(function (s) {
        var v = s.value.trim().toLowerCase();
        if (v) { active[s.getAttribute('data-dc-filter')] = v; any = true; }
      });

      var cards = grid.querySelectorAll('[data-dc-card]');
      var visible = 0;
      cards.forEach(function (card) {
        var match = Object.keys(active).every(function (key) {
          return (card.getAttribute('data-' + key) || '') === active[key];
        });
        card.classList.remove('is-hidden-fold');
        card.style.display = match ? '' : 'none';
        if (match) visible++;
      });

      if (resetBtn) resetBtn.hidden = !any;
      if (emptyMsg) emptyMsg.hidden = visible !== 0;

      // filtering overrides pagination — reveal everything, hide Show More
      var more = root.querySelector('[data-dc-more]');
      if (more) more.closest('.dc__more-wrap').hidden = any;
    }

    /* ---------- Show more ---------- */
    var moreBtn = root.querySelector('[data-dc-more]');
    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        root.querySelectorAll('.is-hidden-fold').forEach(function (c) {
          c.classList.remove('is-hidden-fold');
        });
        moreBtn.closest('.dc__more-wrap').hidden = true;
      });
    }
  }

  function showToast(toast, msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-visible'); }, 2600);
  }
})();